import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: 'assessment',
    loadComponent: () => import('./guest-assessment.component').then((m) => m.GuestAssessmentComponent),
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class guestAssessmentRoutingModule {
  static routes = admin;
}
